import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../shared';

import { LegalInformationComponent } from './legal-information/legal-information.component';
import { LegalInformationRouting } from './legal-informations.routing';
import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';

@NgModule({
  declarations: [LegalInformationComponent],
  imports: [SharedDependenciesModule, LegalInformationRouting, ViDswFooterComponent],
})
export class LegalInformationModule {}
